import { useField } from 'formik';
import { useRef } from 'react';

import '../Forms.scss';

/**
 * DatePicker component
 * @param {{
 *   name: string,
 *   type?: "date" | "time",
 *   disabled?: boolean,
 *   bottomText?: string,
 *   className?: string,
 *   onChange?: (value: string) => void,
 *   min?: string | number,
 *   max?: string | number,
 *   autoFocus?: boolean
 * }} props
 * @returns {JSX.Element} DatePicker
 */
function DatePicker({ name, type = 'date', disabled, bottomText, className, onChange, min, max, autoFocus, label }) {
  const [field, meta] = useField(name);
  const dateTimeRef = useRef(null);

  function openCalendar() {
    dateTimeRef.current.showPicker();
  }

  function handleChange(e) {
    if (onChange) {
      onChange(e.target.value);
    } else {
      field.onChange(e);
    }
  }

  return (
    <div className={`date-input ${className} ${meta.touched && meta.error ? 'error' : ''}`}>
      <label htmlFor={name} onClick={openCalendar}>
        {type}
      </label>

      <div className="input-field">
        <input
          ref={dateTimeRef}
          {...field}
          value={field.value || ""}
          type={type}
          name={name}
          id={name}
          disabled={disabled}
          onChange={handleChange}
          autoFocus={autoFocus}
          min={min}
          max={max}
        />
      </div>
    </div>
  );
}

export default DatePicker;
